import md5 from 'blueimp-md5'

/**
 * get url with params
 * @param url
 * @param params
 * @returns
 */
export function getUrl(url: string, params?: Record<string, any>): string {
  const u = new URL(url, process.env.NEXT_PUBLIC_API_BASE_URL)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      u.searchParams.append(key, value)
    })
  }
  return u.href
}

/**
 * 获取请求头
 * @param config RequestInit
 * @returns
 */
export function getRequestHeaders(url: string) {
  const Timestamp = '1754019181716'
  return {
    Timestamp,
    Sign: signUrl(url, Timestamp),
    'Content-Type': 'application/json',
    Client: 'web',
    Authorization: process.env.NEXT_PUBLIC_PUBLIC_AUTHORIZATION || '',
  }
}

/**
 * 清理参数，去除undefined、null、空字符串
 * @param params Record<string, any>
 * @returns
 */
export function cleanParams(params?: Record<string, any>) {
  if (!params) return params

  Object.keys(params).forEach((key) => {
    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === ''
    ) {
      delete params[key]
    }
  })
  return params
}

/**
 * 通过url生成签名
 */
export function signUrl(apiUrl: string, timestamp?: string): string {
  const url = String(apiUrl).split('')
  const reg = /[a-z0-9]/i
  const urlMap: Record<string, number> = {}
  const urlList: string[] = []

  url.forEach((item) => {
    if (reg.test(item)) {
      if (urlMap[item]) {
        urlMap[item]++
      } else {
        urlMap[item] = 1
        urlList.push(item)
      }
    }
  })

  let str = ''
  urlList.forEach((key) => {
    str += `${key}${urlMap[key]}`
  })
  if (timestamp) {
    str += timestamp
  } else {
    str += new Date().getTime()
  }

  return md5(str)
}
